var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTiktokLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 6.033V3.667c-1.108 0-1.954-.296-2.5-.871a3.7 3.7 0 0 1-.887-2.35V.275L6.375.221v9.612a2.083 2.083 0 1 1-1.35-2.337V5.204A4.317 4.317 0 1 0 8.6 8.934V5.12a6.03 6.03 0 0 0 3.4.912"
})));
export default SvgTiktokLogo;